import React, { PureComponent } from 'react';
import * as dates from '@simplybenefits/sb-dates';
import { connect } from 'react-redux';
import { Modal, Text } from '@simplybenefits/sb-ui-library';
import PhotoGrid from '../Common/PhotoGrid.js';
import pdfImg from '../../../../assets/pdf.png';

class ReviewClaimModal extends PureComponent {
    render() {
        const { submitClaim } = this.props;
        const styles = {
            metaBlock: {
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                paddingBottom: 2
            },
            block: {
                paddingBottom: 10
            },
            receiptPhoto: {
                height: 200,
                width: 'auto',
                alignSelf: 'center',
                backgroundColor: 'transparent',
                marginTop: 10,
                display: 'block',
                margin: 'auto'
            }
        };

        return (
            <Modal
                medium
                testid="submit-claim-modal"
                aria-labelledby="Submit Claim"
                open={true}
                title={ this.props.title }
                primaryButton={{
                    label: "Submit",
                    onClick: submitClaim
                }}
                onClose={ this.props.onClose}
                loader={ this.props.loader }
                onBack={ this.props.onBack }
            >
                <div style={styles.metaBlock}>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                            Patient:
                    </Text>

                    <Text medium>{ this.props.meta.patient.name }</Text>
                </div>

                <div style={styles.metaBlock}>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                            Category:
                    </Text>

                    <Text medium>{ this.props.meta.category }</Text>
                </div>

                <div style={styles.metaBlock}>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                            Service:
                    </Text>

                    <Text medium>{ this.props.meta.service }</Text>
                </div>

                <div style={ styles.metaBlock }>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                        Service Date:
                    </Text>

                    <Text medium>{ dates.getLocalDisplay(this.props.meta.serviceDate) }</Text>
                </div>

                <div style={ styles.metaBlock }>
                    <Text
                        light
                        medium
                        flex={1}
                    >
                        Amount:
                    </Text>

                    <Text medium>${ this.props.meta.amountSubmitted }</Text>
                </div>

                <div style={styles.block}>
                    <Text
                        light
                        medium
                        customStyle={styles.flex}
                        display="block"
                    >
                            Receipt/Invoice:
                    </Text>

                    {
                        !this.props.receiptPhoto ?
                            null
                            : 
                            this.props.receiptPhoto?.file?.type === 'application/pdf' ?
                                <img alt="Receipt" src={ pdfImg } style={styles.receiptPhoto} />
                                :
                                <img alt="Receipt" src={this.props.receiptPhoto.image} style={styles.receiptPhoto} />
                    }

                </div>

                <div style={styles.block}>
                    <Text
                        light
                        medium
                        marginBottom={5}
                        customStyle={styles.flex}
                        display="block"
                    >
                            Supporting Documents:
                    </Text>

                    {
                        this.props.supportingPhotos && this.props.supportingPhotos.length > 0 ?
                            <PhotoGrid
                                photos={this.props.supportingPhotos}
                            />
                            :
                            <Text
                                light
                                small
                            >
                                    No supporting documents.
                            </Text>
                    }
                </div>

                <Text light tiny>
                    By submitting this claim I agree to the Simply Benefits Terms of Service.
                </Text>
            </Modal>
        );
    }
}

export default connect()(ReviewClaimModal);